<template>
  <div class="lg:hidden">
    <button
      class="inline-flex items-center gap-2 rounded-lg bg-highlight px-4 py-2 text-white"
      @click="showMobileMenu = !showMobileMenu"
    >
      <AdjustmentsHorizontalIcon class="size-5" />
      <span class="text-sm font-bold">{{ $t('pages.category.filter') }}</span>
      <InViewChecker
        class="size-0"
        @in-view="showBottomFilterButton = false"
        @out-of-view="showBottomFilterButton = true"
      />
    </button>

    <button
      :class="[
        'fixed left-0 right-0 z-50 mx-4 inline-flex items-center justify-center gap-2 rounded-lg bg-highlight px-4 py-3 text-white transition-all duration-150',
        showBottomFilterButton ? 'bottom-6' : 'bottom-0 translate-y-full',
      ]"
      @click="showMobileMenu = !showMobileMenu"
    >
      <AdjustmentsHorizontalIcon class="size-5" />
      <span class="text-sm font-bold">{{ $t('pages.category.filter') }}</span>
    </button>

    <div
      :class="{
        'translate-y-full': !showMobileMenu,
        'translate-y-0': showMobileMenu,
      }"
      class="fixed bottom-0 left-0 right-0 top-0 z-50 flex h-screen w-full transform flex-col bg-white transition-transform duration-300"
    >
      <div
        class="sticky top-0 flex items-center justify-start border-b bg-highlight p-4 text-white"
      >
        <XMarkIcon
          class="mr-auto size-6 cursor-pointer"
          @click="closeAndReset"
        />
        <h2
          class="absolute left-1/2 -translate-x-1/2 transform text-lg font-bold"
        >
          {{ $t('pages.category.filter_verb') }}
        </h2>
      </div>

      <div class="flex-1 overflow-y-auto p-4">
        <div class="space-y-4">
          <FiltersWrapper />
        </div>
      </div>

      <div class="sticky bottom-0 border-t bg-gray-50 p-4">
        <button
          class="w-full rounded-lg bg-highlight py-3 text-center text-lg font-bold text-white"
          @click="closeAndFilter"
        >
          <AisStats>
            <template #default="{ nbHits }">
              {{ $t('pages.category.filter_n_results', { count: nbHits }) }}
            </template>
          </AisStats>
        </button>
      </div>
    </div>
  </div>

  <button
    :class="[
      'fixed right-0 z-50 mr-4 flex h-8 w-8 items-center justify-center rounded-full bg-highlight transition-all duration-150',
      showBottomFilterButton ? 'bottom-20' : 'bottom-0 translate-y-full',
      showScrollToTop ? 'lg:bottom-12 lg:right-0 lg:mr-5' : 'bottom-0',
    ]"
    type="button"
    @click.prevent="scrollToTop"
  >
    <FontAwesomeIcon
      :icon="{ prefix: 'fas', iconName: 'chevron-up' }"
      class="text-white"
    />
  </button>
</template>

<script setup lang="ts">
import InViewChecker from '@/components/States/InViewChecker.vue';
import FiltersWrapper from '@/pages/CategoryPage/Partials/FiltersWrapper.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { AdjustmentsHorizontalIcon, XMarkIcon } from '@heroicons/vue/20/solid';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { onMounted, onUnmounted, ref, watch } from 'vue';

const showMobileMenu = ref(false);
const showBottomFilterButton = ref(false);
const showScrollToTop = ref(false);
const breakpoints = useBreakpoints(breakpointsTailwind);
const isDesktop = breakpoints.greaterOrEqual('lg');

const scrollToTop = () => window.scrollTo({ top: 0 });

function handleScroll() {
  if (isDesktop.value) {
    showScrollToTop.value = window.scrollY > 600;
    return;
  }
  showScrollToTop.value = true;
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

function closeAndReset() {
  showMobileMenu.value = false;
}

function closeAndFilter() {
  showMobileMenu.value = false;
}

watch(showMobileMenu, show => {
  document.body.classList.toggle('overflow-hidden', show);
});
</script>
